import React from 'react';
import PropTypes from 'prop-types';
import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";
import TransactionKey from "../Display/TransactionKey";


const ReturnSettingTable = ({ data }) => {

  if (!data.returns){
    return (
      <div/>
    );
  }

  let returns = data.returns;
  return (
    <div className="calc-setting-table">
      <table className="table">
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="3" className="text-left calc-setting-table-header">Skilagreinar sem búið er að skila</th>
        </tr>
        <tr>
          <th className="text-left">Færslulykill</th>
          <th className="text-right">Dagsetning</th>
          <th className="text-right">Upphæð</th>
        </tr>
        </thead>
        <tbody>
        {returns.map(function(item,i){
          return(
            <tr key={i}>
              <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
              <td className="text-right"><Date data={item.returnDate}/></td>
              <td className="text-right"><Amount data={item.amount}/></td>
            </tr>);
        })}
        </tbody>
      </table>
    </div>
  );
};

ReturnSettingTable.propTypes = {
  data: PropTypes.object,
};

export default ReturnSettingTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/ReturnSettingTable.js